import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/exhibitions',
      name: 'exhibitions',
      component: resolve => require(['./views/Exhibition.vue'],resolve)
    },
    {
      path: '/kaKa',
      name: 'kaKa',
      component: resolve => require(['./views/kaKa.vue'],resolve)
    },
    {
      path: '/lePao',
      name: 'lePao',
      component: resolve => require(['./views/lePao.vue'],resolve)
    },
    {
      path: '/zgyh',
      name: 'zgyh',
      component: resolve => require(['./views/zgyh.vue'],resolve)
    },
    {
      path: '/xianZhi',
      name: 'xianZhi',
      component: resolve => require(['./views/xianZhi.vue'],resolve)
    },
    {
      path: '/cyb',
      name: 'cyb',
      component: resolve => require(['./views/cyb.vue'],resolve)
    },
    {
      path: '/linYun',
      name: 'linYun',
      component: resolve => require(['./views/linYun.vue'],resolve)
    },
    {
      path: '/vitte',
      name: 'vitte',
      component: resolve => require(['./views/vitte.vue'],resolve)
    },
    {
      path: '/yycf',
      name: 'yycf',
      component: resolve => require(['./views/yycf.vue'],resolve)
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if(this.app.$route.fullPath==='/exhibitions'){
      document.querySelector('#app').scrollTop = 0
    }
    document.body.style.overflowY = ''
  }
})
